import { h } from "preact"

export default function Calendar(props: any) {
  return h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      ...props,
    },
    h("path", {
      d:
        "M28 5h-4V3c0-.6-.5-1-1-1s-1 .5-1 1v2H10V3c0-.6-.5-1-1-1s-1 .5-1 1v2H4a2 2 0 0 0-2 2v21c0 1.1.9 2 2 2h24a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zM8 7v1c0 .6.5 1 1 1s1-.5 1-1V7h12v1c0 .6.5 1 1 1s1-.5 1-1V7h4v6H4V7h4zM4 28V15h24v13H4z",
    }),
  )
}
